import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Music } from "lucide-react";
import DynamicIcon from "./DynamicIcon";

function Feature({ f, color }) {
  const body = (
    <>
      <DynamicIcon name={f.icon} className="w-4 h-4" style={{ color }} />
      <span>{f.text}</span>
    </>
  );
  const base = "flex items-center gap-3 text-white/85 text-[15px]";
  if (f.href) {
    return (
      <Link
        to={f.href}
        className={`${base} hover:text-white transition-colors`}
        data-testid={`feature-${f.text.replace(/\s+/g, "-").toLowerCase().slice(0, 30)}`}
      >
        {body}
        <ArrowRight className="w-3.5 h-3.5 text-white/40 -ml-1" />
      </Link>
    );
  }
  return <div className={base}>{body}</div>;
}

export default function DualCards({ cards }) {
  const { music, teams } = cards;
  return (
    <section className="relative bg-black px-6 pb-24">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* MUSIC CARD */}
        <div className="card-glow-orange relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-neutral-950 to-black p-6 sm:p-8 md:p-10 hover:border-[#ff8a3c]/40 transition-colors group">
          <div className="relative z-10">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#ffa957] to-[#ff6a2b] flex items-center justify-center shadow-lg shadow-[#ff6a2b]/20">
              <Music className="w-6 h-6 text-black" />
            </div>
            <h3 className="mt-10 font-display font-bold text-xl sm:text-3xl text-white leading-none whitespace-nowrap">{music.title}</h3>
            <p className="mt-3 font-mono-caps text-xs tracking-[0.3em] text-[#ff8a3c]">{music.subtitle}</p>
            <ul className="mt-8 space-y-4">
              {music.features.map((f, i) => (
                <li key={i}><Feature f={f} color="#ff8a3c" /></li>
              ))}
            </ul>
            <Link to={music.cta_link} className="mt-10 inline-flex items-center gap-2 font-mono-caps uppercase tracking-[0.15em] text-sm text-[#ff8a3c] hover:text-[#ffb46b] transition-colors">
              {music.cta_label}
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {/* TEAMS CARD */}
        <div className="card-glow-teal relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-neutral-950 to-black p-6 sm:p-8 md:p-10 hover:border-[#2ec9a8]/40 transition-colors group">
          <div className="relative z-10">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#5be0c3] to-[#2ec9a8] flex items-center justify-center shadow-lg shadow-[#2ec9a8]/20">
              <svg viewBox="0 0 24 24" fill="none" className="w-6 h-6 text-black" stroke="currentColor" strokeWidth="2">
                <circle cx="9" cy="7" r="3" />
                <circle cx="17" cy="9" r="2.5" />
                <path d="M3 20c0-3 3-5 6-5s6 2 6 5" strokeLinecap="round" />
                <path d="M14 20c0-2 2-3.5 4-3.5s3 1 3 3.5" strokeLinecap="round" />
              </svg>
            </div>
            <h3 className="mt-10 font-display font-bold text-xl sm:text-3xl text-white leading-none whitespace-nowrap">{teams.title}</h3>
            <p className="mt-3 font-mono-caps text-xs tracking-[0.3em] text-[#2ec9a8]">{teams.subtitle}</p>
            <ul className="mt-8 space-y-4">
              {teams.features.map((f, i) => (
                <li key={i}><Feature f={f} color="#2ec9a8" /></li>
              ))}
            </ul>
            <Link to={teams.cta_link} className="mt-10 inline-flex items-center gap-2 font-mono-caps uppercase tracking-[0.15em] text-sm text-[#2ec9a8] hover:text-[#7ff0d3] transition-colors">
              {teams.cta_label}
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
